import lax from "lax.js";

export default function() {
    lax.init();

    lax.addDriver("scrollY", () => window.scrollY);

    lax.addElements(".animate-background", {
        scrollY: {
            translateY: [
                ["elInY", "elCenterY", "elOutY"],
                {
                    1055: [-50, 0, 50],
                    1056: [-100, 0, 100],
                },
            ],
        },
    });
}
